// eslint-disable-next-line import/no-extraneous-dependencies
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface Post {
  isAuth: boolean
}

const initialState: Post = {
  isAuth: false,
}

export const appSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {
    setIsAuth: (state, action: PayloadAction<boolean>) => {
      // eslint-disable-next-line no-param-reassign
      state.isAuth = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setIsAuth,
} = appSlice.actions

export default appSlice.reducer
